import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import {
  postBillingGrtByItinerary,
  postBillingGrtByItineraryV2,
} from '../../../../../actions';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { generateGrtBillingByItineraryEndpoint } from '../../../../../config/endpoints';
import { POST } from '../../../../../config/permissions';

const ItinerarySendGrtButton = ({
  itineraryId,
  useV2,
  dispatchPostBillingGrtByItinerary,
  dispatchPostBillingGrtByItineraryV2,
}) => {
  const onSendGrt = () => {
    if (useV2) {
      dispatchPostBillingGrtByItineraryV2(itineraryId);
    } else {
      dispatchPostBillingGrtByItinerary(itineraryId);
    }
  };
  return (
    <Button color="success" className="border" onClick={onSendGrt}>
      <i className="fa fa-send" /> Enviar GRT
    </Button>
  );
};

ItinerarySendGrtButton.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  useV2: PropTypes.bool,
  dispatchPostBillingGrtByItinerary: PropTypes.func.isRequired,
  dispatchPostBillingGrtByItineraryV2: PropTypes.func.isRequired,
};

ItinerarySendGrtButton.defaultProps = {
  useV2: false,
};

const mapDispatchToProps = {
  dispatchPostBillingGrtByItinerary: postBillingGrtByItinerary,
  dispatchPostBillingGrtByItineraryV2: postBillingGrtByItineraryV2,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(ItinerarySendGrtButton);

export default withEndpointAuthorization({
  url: generateGrtBillingByItineraryEndpoint(0),
  permissionType: POST,
})(connectedComponent);
